import { cn } from "@/lib/utils";

const FLAG_EDGE: Array<[number, number]> = [
  [0, 14],
  [50, 50],
  [100, 14],
];

const BAND = 76;
const TRIM = 20;
const OVERLAP = 6;

const clipPolygon = `polygon(0% 0%, 100% 0%, ${FLAG_EDGE.map(([x, depth]) => `${x}% calc(100% - ${BAND - depth}px)`)
  .reverse()
  .join(", ")})`;

const hemPath = `M${FLAG_EDGE.map(([x, depth]) => `${x},${depth - OVERLAP}`).join(" L")} L${FLAG_EDGE.map(
  ([x, depth]) => `${x},${depth + TRIM}`,
)
  .reverse()
  .join(" L")} Z`;

interface PointedSectionBackgroundProps {
  bodyClassName?: string;
}

const PointedSectionBackground = ({ bodyClassName }: PointedSectionBackgroundProps) => (
  <>
    <svg
      aria-hidden="true"
      className="pointer-events-none absolute left-0 top-full w-full"
      viewBox={`0 0 100 ${BAND}`}
      preserveAspectRatio="none"
      style={{ height: `${BAND}px` }}
    >
      <path d={hemPath} fill="hsl(var(--flag-trim))" />
    </svg>

    <div
      aria-hidden="true"
      className={cn("absolute inset-x-0 top-0 section-dark", bodyClassName)}
      style={{ bottom: `-${BAND}px`, clipPath: clipPolygon }}
    />
  </>
);

export default PointedSectionBackground;
